import AccountType from 'Components/onboarding/steps/AccountType';
import Website from 'Components/onboarding/steps/Website';
import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom'
import { RootState, store } from 'store';
import { useNavigate } from 'react-router-dom';
import GSTDetails from 'Components/onboarding/steps/GSTDetails';
import AddSocialAccountStep from 'Components/onboarding/steps/AddSocialAccountStep';
import { onboardingStepSortOrder } from 'types/user';
const Onboarding = () => {

    const [searchParams, setSearchParams] = useSearchParams();
    const step = searchParams.get('step');
    const location = useLocation();
    const intendedRedirect =
        (location.state as any)?.from || "/";
    const navigate = useNavigate();

    const [currentStep, setCurrentStep] = useState(step);

    useEffect(() => {
        setCurrentStep(step)
    }, [step])

    const onboardingSteps = useSelector((state: RootState) => state.auth.selectedAgency?.onboarding_steps)

    const pendingSteps = useMemo(() => {
        if (!onboardingSteps) return [];
        // return Object.entries(onboardingSteps).map(([key, step]) => ({ key, ...step })).sort((a, b) => a.sort_order - b.sort_order)
        // return Object.entries(onboardingSteps).map(([key, step]) => ({ key, ...step })).filter((step) => step.key === 'social_account').sort((a, b) => a.sort_order - b.sort_order)
        return Object.entries(onboardingSteps).map(([key, step]) => ({ key, ...step })).filter((step) => step.status === 'pending').sort((a, b) => (onboardingStepSortOrder[a.key as keyof typeof onboardingStepSortOrder] ?? 999) - (onboardingStepSortOrder[b.key as keyof typeof onboardingStepSortOrder] ?? 999))
    }, [onboardingSteps])

    useEffect(() => {
        if (!pendingSteps.length) {
            navigate(intendedRedirect);
            return;
        }
        if (!currentStep || (currentStep && !pendingSteps.map((s) => s.key).includes(currentStep))) {
            setSearchParams({ step: pendingSteps[0].key })
        }
       
    }, [pendingSteps, currentStep])


    return (
        <div>
            {
                currentStep === 'type' && <AccountType />
            }
            {
                currentStep === 'website_url' && <Website />
            }
            {
                currentStep === 'gst' && <GSTDetails />
            }
            {
                currentStep === 'social_account' && <AddSocialAccountStep />
            }
        </div>
    )
}

export default Onboarding